import { Check, Close, DeleteOutlined } from "@mui/icons-material";
import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Snackbar,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { DELETE } from "../../../Utilities/BaseService";

const initialFeedback = {
    loading: false,
    show: false,
    message: "",
    severity: "",
};

export default function DeleteBulkCollections({
    collectionIds,
    changeCount,
    setChangeCount,
}: {
    collectionIds: string[];
    changeCount: any;
    setChangeCount: any;
}) {
    const [feedback, setFeedback] = useState(initialFeedback);
    const [openDialog, setOpenDialog] = useState(false);

    async function deleteCollectionsInBulk(ids: string[]) {
        console.log(ids);

        if (!ids.length) {
            setFeedback({
                loading: false,
                show: true,
                message: "No collections selected",
                severity: "info",
            });
            return;
        }

        setFeedback((f) => ({ ...f, loading: true }));

        try {
            const response = await DELETE(
                "/reading/collection/many/soft",
                {},
                {
                    ids,
                }
            );

            setFeedback({
                loading: false,
                show: true,
                message: response?.data?.message,
                severity: response?.status === 200 ? "success" : "error",
            });

            console.log({ response });
            setOpenDialog(false);
            setChangeCount((c: any) => c + 1);
        } catch (error: any) {
            console.log({ error });
            setFeedback((f) => ({
                loading: false,
                show: true,
                message: error.response.data.message,
                severity: "error",
            }));
        }
    }

    return (
        <>
            <IconButton
                disabled={feedback.loading || !collectionIds.length}
                size="small"
                onClick={() => {
                    setOpenDialog(true);
                    // deleteCollectionsInBulk(collectionIds);
                }}
            >
                {feedback.loading ? (
                    <CircularProgress color="secondary" size={20} />
                ) : feedback.severity === "error" ? (
                    <Close color="error" />
                ) : feedback.severity === "success" ? (
                    <Check color="success" />
                ) : (
                    <DeleteOutlined />
                )}
            </IconButton>

            <Snackbar
                open={feedback.show}
                autoHideDuration={3000}
                onClose={() => setFeedback(initialFeedback)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert severity={feedback.severity as any}>
                    {feedback.message}
                </Alert>
            </Snackbar>

            <Dialog
                open={openDialog}
                onClose={
                    feedback.loading ? undefined : () => setOpenDialog(false)
                }
            >
                <DialogTitle>Are You Sure?</DialogTitle>
                <DialogContent>
                    <Typography>
                        This will irreversibly delete the item, continue?
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={() => setOpenDialog(false)}
                        variant="outlined"
                        disabled={feedback.loading}
                    >
                        Close
                    </Button>

                    <Button
                        color="error"
                        variant="outlined"
                        onClick={() => deleteCollectionsInBulk(collectionIds)}
                        disabled={feedback.loading}
                    >
                        {feedback.loading ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
